export class OstCache {
  /**
   *
   * @param {number} subscriptionId
   * @param {boolean} readOnlyData
   * @param {Object|null} init
   * @param {Object|null} catalog
   * @param {Object|null} summary
   * @param {Object|null} update
   */
  constructor({
    subscriptionId,
    readOnlyData,
    init = null,
    catalog = null,
    summary = null,
    update = null,
  }) {
    this.subscriptionId = subscriptionId;
    this.init = init;
    this.catalog = catalog;
    this.summary = summary;
    this.update = update;
    this.readOnlyData = readOnlyData;
  }

  /**
   *
   * @return {boolean}
   */
  hasInit() {
    return this.init !== null;
  }

  /**
   *
   * @return {boolean}
   */
  hasCatalog() {
    return this.catalog !== null;
  }

  /**
   *
   * @return {boolean}
   */
  hasSummary() {
    return this.summary !== null;
  }

  /**
   *
   * @return {boolean}
   */
  hasUpdate() {
    return this.update !== null;
  }

  /**
   *
   * @return {?string}
   */
  getBasketId() {
    return this.init?.onlineBasketId;
  }
}
